import {useRef, useEffect} from "react";
import {Dropdown} from "primereact/dropdown";
import {Calendar} from "primereact/calendar";

const CustomerHeaderSection = ({
	availableClients,
	selectedClient,
	setSelectedClient,
	availableOrders,
	selectedOrder,
	selectedClientOrders,
	setSelectedOrder,
	shipmentDate,
	setShipmentDate,
	isLoading,
	isEditMode,
	resetForm,
	furnitureItems,
	setAvailableOrders,
	setSelectedClientOrders,
}) => {
	const dateInputRef = useRef(null);

	const handleOrderChange = (orderValue) => {
		if (isEditMode) return;

		setSelectedOrder(orderValue);

		if (orderValue && !selectedClient) {
			const orderItem = furnitureItems.find(
				(item) => item.unique.name === orderValue
			);

			if (orderItem) {
				const clientName = orderItem.demand_furniture?.demand?.customer?.name;
				if (clientName) {
					setSelectedClient(clientName);
				}
			}
		}
	};

	useEffect(() => {
		if (isEditMode) return;

		if (!selectedClient) {
			setAvailableOrders([]);
			setSelectedOrder(null);
			setSelectedClientOrders([]);
			const allOrders = furnitureItems
				.map((item) => item.unique.name)
				.filter(Boolean);
			setAvailableOrders(Array.from(new Set(allOrders)));
			return;
		}

		const clientOrders = furnitureItems
			.filter(
				(item) =>
					item.demand_furniture?.demand?.customer?.name === selectedClient
			)
			.map((item) => item.unique.name)
			.filter(Boolean);

		const uniqueOrders = Array.from(new Set(clientOrders));
		setAvailableOrders(uniqueOrders);
		setSelectedClientOrders(uniqueOrders);

		if (selectedOrder && !uniqueOrders.includes(selectedOrder)) {
			setSelectedOrder(null);
		}
	}, [
		selectedClient,
		furnitureItems,
		isEditMode,
		selectedOrder,
		setAvailableOrders,
		setSelectedClientOrders,
		setSelectedOrder,
	]);

	return (
		<div className="flex items-center justify-between w-full gap-4">
			<div className="flex items-center gap-4">
				<div>
					<p className="pb-2 text-xl">Клиент</p>
					<Dropdown
						options={availableClients}
						onChange={(e) => {
							if (isEditMode) return;
							if (e.value === undefined) resetForm();
							setSelectedClient(e.value);
						}}
						placeholder="Клиентни танлаш"
						value={selectedClient}
						className="w-[12em] border h-[46px] pt-[2px]"
						loading={isLoading}
						showClear={!isEditMode}
						filter
						disabled={isEditMode}
					/>
				</div>
				<div>
					<p className="pb-2 text-xl">Заказ</p>
					<Dropdown
						options={selectedOrder ? selectedClientOrders : availableOrders}
						onChange={(e) => {
							if (e.value === undefined) resetForm();
							handleOrderChange(e.value);
						}}
						value={selectedOrder}
						placeholder="Заказни танлаш"
						className="w-[12em] border h-[46px] pt-[2px]"
						loading={isLoading}
						showClear={!isEditMode}
						filter
						disabled={isEditMode}
					/>
				</div>
			</div>
			<div>
				<p className="pb-2 text-xl">Сана</p>
				<div className="relative min-w-[12em] border border-gray-300 rounded-md shadow-sm bg-white hover:border-blue-500 focus-within:border-blue-500 focus-within:ring-1 focus-within:ring-blue-500 transition-all duration-200">
					<Calendar
						value={shipmentDate}
						onChange={(e) => setShipmentDate(e.value)}
						className="!w-full calendar-custom"
						dateFormat="dd.mm.yy"
						inputRef={dateInputRef}
						inputClassName="!border-none !shadow-none !outline-none px-3 py-3 w-full text-sm bg-transparent"
						onSelect={() => {
							setTimeout(() => dateInputRef.current?.blur(), 125);
						}}
						showIcon
						iconPos="right"
					/>
				</div>
			</div>
		</div>
	);
};

export default CustomerHeaderSection;
